export default __webpack_public_path__ + "static/media/P2_Tip_Box.df89110c.svg";